/**
 * 
 */
export default function connectIDGen(...params) {
  const lastParam = params[params.length - 1];
  const result = params.reduce((acc, item) => (acc + item), 0);
  return result * lastParam;
}